<div class="date-range-picker-container">
  <div *ngIf="title" class="title">{{ title }}</div>
  <div *ngIf="isRange" class="form-wrapper">
    <mat-label class="grey-label">{{ 'components.date_range_picker.date_range' | translate }}</mat-label>
    <mat-form-field appearance="outline" class="time-type small-select">
      <mat-select (selectionChange)="setDays($event.value)" [formControl]="selectedDays" [panelClass]="'small-select'">
        <mat-option *ngFor="let day of daysRange" [value]="day">
          {{ day }} {{ 'components.analystics_filters_modal.' + (day === 1 ? 'day' : 'days') | translate }}
        </mat-option>
      </mat-select>
      <app-form-field-error-display matError></app-form-field-error-display>
    </mat-form-field>

    <app-date-range-badge (selectRange)="setDays($event)" [isFutureTime]="isFutureTime"
                          class="range-picker-badge"></app-date-range-badge>
  </div>
  <div class="date-range-picker-wrapper">
    <div class="form-wrapper">
      <mat-label class="grey-label">{{ 'components.date_range_picker.enter_date_range' | translate }}</mat-label>
      <mat-form-field appearance="outline" class="small-input">
        <mat-date-range-input [rangePicker]="picker">
          <input [formControl]="dateStart" matStartDate
                 placeholder="{{ 'components.date_range_picker.start_date' | translate}}"/>
          <input [formControl]="dateEnd" matEndDate
                 placeholder="{{ 'components.date_range_picker.end_date' | translate}}"/>
        </mat-date-range-input>
        <mat-datepicker-toggle [disableRipple]="true" [for]="picker" matIconSuffix>
          <mat-icon class="calendar-icon" matDatepickerToggleIcon>calendar_month</mat-icon>
        </mat-datepicker-toggle>
        <mat-date-range-picker #picker panelClass="date-range-picker-panel"></mat-date-range-picker>
      </mat-form-field>
    </div>
  </div>
</div>
